import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoginPage from '../components/LoginPage';
import { useAuth } from '../contexts/AuthContext';
import LoadingState from '../components/common/LoadingState';

const LoginPageWrapper: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname ?? '/';

  if (isLoading) return <LoadingState fullPage />;
  if (isAuthenticated) return <Navigate to={from} replace />;

  return <LoginPage />;
};

export default LoginPageWrapper;
